export const DROPDOWN_OPTIONS = [
  {
    text: 'Populares',
    value: 'popular'
  },
  {
    text: 'Mis Películas',
    value: 'user'
  }
];
